var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',[_c('WorkflowsPanels',{attrs:{"type":"payment","workflows":_vm.contract.workflows},on:{"update-workflows":function($event){return _vm.$emit('update-workflows')}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }